<!-- <div class="bg-app-opactiy-5 gratuity" *ngIf="subTotalAmount < 30"> -->
<div class="bg-app-opactiy-5 gratuity">
  <div class="row">
    <h4>Tip</h4>
    <mat-button-toggle-group
      color="primary"
      [value]="tipToggleVal"
      (change)="setTipAmount($event.value)"
      #group="matButtonToggleGroup"
    >
      <mat-button-toggle [value]="tip" *ngFor="let tip of tipList">
        <div class="btn-toggle-wrapper">
          <span>{{ tip }}%</span>
          <label>{{
            (tip * subTotalAmount) / 100 | currency : basicInfo.currencyCode
          }}</label>
        </div>
      </mat-button-toggle>
      <mat-button-toggle value="custom">
        <div class="btn-toggle-wrapper">
          <span>{{ "Other" | translate }}</span>
          <label>{{ "Custom" | translate }}</label>
        </div>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <ng-container *ngIf="group.value === 'custom'">
    <div class="row">
      <h4 class="custom">{{ "Tip Amount" | translate }}</h4>
      <input
        matInput
        placeholder="{{ 'Enter tip amount' | translate }}"
        min="0"
        class="bg-card-4 inputTxt"
        type="number"
        #tipModel
        [value]="tipAmount"
        (blur)="setCustomTip(tipModel.value)"
        (keyup.enter)="setCustomTip(tipModel.value)"
        numbersOnly
      />
    </div>
  </ng-container>
</div>
<!-- <div class="bg-app-opactiy-5 gratuity" *ngIf="subTotalAmount >= 30"> -->
<div class="bg-app-opactiy-5 gratuity" *ngIf="false">
  <div class="row">
    <h4>{{ "Gratuity Tip" | translate }}</h4>
    <mat-button-toggle-group
      color="primary"
      name="fontStyle"
      aria-label="'Font Style' | translate"
      (change)="setGratuityTip($event.value)"
      #group="matButtonToggleGroup"
    >
      <mat-button-toggle
        [value]="gratuity"
        *ngFor="let gratuity of gratuityTipList"
        style="line-height: 0"
      >
        <div class="flex-column" style="line-height: 2">
          <span>{{ gratuity }}%</span>
          <label>{{
            (gratuity * subTotalAmount) / 100
              | currency : basicInfo.currencyCode
          }}</label>
        </div>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>
